import { SIGNALR_CONNECTED_TYPE, SIGNALR_INVOKE_TYPE, SIGNALR_START_TYPE } from 'services/signalR.types';

export default {
  LOADING_GET_ASSET_INFO: 'LOADING_GET_ASSET_INFO',
  SUCCESS_GET_ASSET_INFO: 'SUCCESS_GET_ASSET_INFO',
  ERROR_GET_ASSET_INFO: 'ERROR_GET_ASSET_INFO',

  LOADING_GET_ASSETS: 'LOADING_GET_ASSETS',
  SUCCESS_GET_ASSETS: 'SUCCESS_GET_ASSETS',
  ERROR_GET_ASSETS: 'ERROR_GET_ASSETS',

  LOADING_GET_COINS: 'LOADING_GET_COINS',
  SUCCESS_GET_COINS: 'SUCCESS_GET_COINS',
  ERROR_GET_COINS: 'ERROR_GET_COINS',

  LOADING_GET_SPOT_TREND: 'LOADING_GET_SPOT_TREND',
  SUCCESS_GET_SPOT_TREND: 'SUCCESS_GET_SPOT_TREND',
  ERROR_GET_SPOT_TREND: 'ERROR_GET_SPOT_TREND',

  LOADING_GET_SPOT_COMMISSIONS: 'LOADING_GET_SPOT_COMMISSIONS',
  SUCCESS_GET_SPOT_COMMISSIONS: 'SUCCESS_GET_SPOT_COMMISSIONS',
  ERROR_GET_SPOT_COMMISSIONS: 'ERROR_GET_SPOT_COMMISSIONS',

  LOADING_GET_ASSETS_GROUPS: 'LOADING_GET_ASSETS_GROUPS',
  SUCCESS_GET_ASSETS_GROUPS: 'SUCCESS_GET_ASSETS_GROUPS',
  ERROR_GET_ASSETS_GROUPS: 'ERROR_GET_ASSETS_GROUPS',

  LOADING_GET_COINS_GROUPS: 'LOADING_GET_COINS_GROUPS',
  SUCCESS_GET_COINS_GROUPS: 'SUCCESS_GET_COINS_GROUPS',
  ERROR_GET_COINS_GROUPS: 'ERROR_GET_COINS_GROUPS',

  LOADING_GET_FAVORITE_ASSETS: 'LOADING_GET_FAVORITE_ASSETS',
  SUCCESS_GET_FAVORITE_ASSETS: 'SUCCESS_GET_FAVORITE_ASSETS',
  ERROR_GET_FAVORITE_ASSETS: 'ERROR_GET_FAVORITE_ASSETS',

  LOADING_SET_FAVORITE_ASSET: 'LOADING_SET_FAVORITE_ASSET',
  SUCCESS_SET_FAVORITE_ASSET: 'SUCCESS_SET_FAVORITE_ASSET',
  ERROR_SET_FAVORITE_ASSET: 'ERROR_SET_FAVORITE_ASSET',

  LOADING_GET_FAVORITE_COINS: 'LOADING_GET_FAVORITE_COINS',
  SUCCESS_GET_FAVORITE_COINS: 'SUCCESS_GET_FAVORITE_COINS',
  ERROR_GET_FAVORITE_COINS: 'ERROR_GET_FAVORITE_COINS',

  LOADING_SET_FAVORITE_COIN: 'LOADING_SET_FAVORITE_COIN',
  SUCCESS_SET_FAVORITE_COIN: 'SUCCESS_SET_FAVORITE_COIN',
  ERROR_SET_FAVORITE_COIN: 'ERROR_SET_FAVORITE_COIN',
  
  SIGNALR_START: SIGNALR_START_TYPE,
  SIGNALR_CONNECTED: SIGNALR_CONNECTED_TYPE,
  SIGNALR_INVOKE: SIGNALR_INVOKE_TYPE,
  SIGNALR_INCOME_RECEIVE_LASTPRICE: 'SIGNALR_INCOME/trading-pair-price-receive-lastprice',
  SIGNALR_INCOME_RECEIVE_BESTBID: 'SIGNALR_INCOME/trading-pair-price-receive-bestbid',
  SIGNALR_INCOME_RECEIVE_BESTASK: 'SIGNALR_INCOME/trading-pair-price-receive-bestask',
} as const;
